module.exports = __webpack_public_path__ + "static/media/34.28044f6a.svg";